<template>
  <div class="workflow-state-pipeline-widget timeline">
    <Spin v-if="loadingWorkflowUserTransitions">{{ $t('loading') }}</Spin>
    <ul class="workflow-transitions" v-else>
      <div v-if="currentState" class="warning">
        <Tooltip :content="currentState.updated_at">
          <span>{{ $t('workflow.status_title') }}: </span>
          <span>{{ $t(`workflow.status.${ currentState.to }`) }}</span>
        </Tooltip>
      </div>
      <Button v-if="displayEditButton" style="float: right" type="text" size="small" @click="isEditing = !isEditing">{{ isEditing ? 'cancel editing' : 'edit' }}</Button>
      <li class="container group" v-for="(p, pi) in reducedDisplay" :key="pi">
        <div class="group title">{{ p.label }}</div>
        <ul class="items">
          <li class="container item"
              v-for="config in p.data"
              :key="`item-${pi}-${config.key}` + (config.context && config.context.sub ? `-${config.context.sub}` : '')">
              <WorkflowTransitionNode
              :title="config.label"
              :config="config"
              :editing="isEditing"
              :state-histories="findStateHistories(config)"
              :refresh-workflow-func="refreshWorkflowModelUserTransitions"
              :is-transition-enabled="isTransitionEnabled(config)"
              workflow-name="quote"
              workflow-model-type="quote"
              :workflow-model-id="quoteId"
              @dingtalk-request-completed="setDingtalkLastRemindDate"
              :lastRemindDates="workflowLastRemindDates">
            </WorkflowTransitionNode>
          </li>
        </ul>
      </li>

      <!-- <button @click="debug(p.data)"></button> -->
    </ul>
  </div>
</template>

<script>
import UTILS from '@/view/quote/data/utils'
import { mapActions, mapGetters } from 'vuex'
import WorkflowTransitionNode from './workflow-transition-node'
export default {
  name: 'WorkflowStatePipelineWidget',
  components: {
    WorkflowTransitionNode
  },
  props: {
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    workflowName: {
      type: String,
      required: true
    },
    modelType: {
      type: String,
      required: true
    },
    modelId: {
      type: [Number, String],
      required: true
    },
    data: {
      type: Array,
      required: false
    },
    display: {
      type: Array,
      required: true
    },
    displayEditButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters([
      'users',
      'getWorkflowModelUserTransitions'
    ]),
    isNew: function () { return UTILS.isWorkflowNew(this.modelWorkflowTransition['state_histories']) },
    currentState: function () {
      return this.modelWorkflowTransition['state']
    },
    stateHistories: function () {
      return this.modelWorkflowTransition['state_histories']
    },
    enabledTransitions: function () {
      return this.modelWorkflowTransition['enabled_transitions']
    },
    reducedDisplay: function () {
      if (UTILS.isWorkflowNew(this.modelWorkflowTransition['user_transitions'])) {
        return this.display
      }

      return UTILS.reduceWorkflowDisplayItems(
        this.display,
        this.modelWorkflowTransition['user_transitions'],
        this.isEditing
      )
    }
  },
  watch: {
    'isNew': function (val) {
      this.getIsNew()
    },
    'modelId': function (value) {
      this.quoteId = value
      this.init()
    }
  },
  data () {
    return {
      dataClone: [],
      usersFiltered: [],
      saving: false,
      loadingWorkflowUserTransitions: true,
      modelWorkflowTransition: {},
      isEditing: false,
      quoteId: this.modelId,
      workflowLastRemindDates: {}
    }
  },
  created () {
    this.init()
    this.getIsNew()
    this.setDingtalkLastRemindDate()
  },
  methods: {
    ...mapActions([
      'getUsers',
      'loadWorkflowModelUserTransitions',
      'getDingtalkLastRemindDates'
    ]),
    init () {
      this.getUsers().then((resp) => {
        this.refreshWorkflowModelUserTransitions()
      })
    },
    refreshWorkflowModelUserTransitions() {
      this.loadingWorkflowUserTransitions = true
      this.loadWorkflowModelUserTransitions({
        workflowName: this.workflowName,
        modelType: this.modelType,
        modelId: this.quoteId
      }).then(resp => {
        this.modelWorkflowTransition = this.getWorkflowModelUserTransitions(this.workflowName)
      }).finally(() => {
        this.loadingWorkflowUserTransitions = false
      })
    },
    findStateHistories (transitionConfig) {
      // console.log("WElCOMING THE AGENTS", this.reducedDisplay)
      let currentTransition = _.cloneDeep(transitionConfig)
      let histories = []
      // since we've buttons also configured transition, that we also need to look for

      if (currentTransition.buttons) {
        currentTransition.buttons.map(btn => {
          let splitIndex = btn.transition.indexOf(':')
          if (splitIndex !== -1) {
            btn.context = { 'sub': btn.transition.substr(splitIndex + 1) }
            btn.transition = btn.transition.substr(0, splitIndex)
          }

          let tempHist = UTILS.getWorkflowTransitionStateHistories(btn, this.stateHistories)
          if (tempHist.length > 0) histories.push(...tempHist)
        })
      } else {
        histories = UTILS.getWorkflowTransitionStateHistories(currentTransition, this.stateHistories)
      }
      return histories
    },
    isTransitionStateActive (currentTransition, stateHistories) {
      return UTILS.getWorkflowTransitionActiveState(currentTransition, stateHistories)
    },
    isTransitionEnabled: function (currentTransitionConfig) {
      let isTransitionEnabled = _.findIndex(this.enabledTransitions, { transition: currentTransitionConfig.transition }) !== -1

      // Exclude those has context and already submitted
      let stateNotExecuted = true
      if (currentTransitionConfig.context && currentTransitionConfig.context.sub) {
        stateNotExecuted = _.findIndex(this.stateHistories, o => {
          return o.transition === currentTransitionConfig.transition && o.context.sub === currentTransitionConfig.context.sub
        }) === -1
      }

      // let isOnCurrentState = currentTransitionConfig.transition === this.currentState.transition

      return isTransitionEnabled && (stateNotExecuted)
    },
    isButtonActive (currentTransitionName, enabledTransitions) {
      return !UTILS.getWorkflowTransitionButtonActiveState(currentTransitionName, enabledTransitions)
    },
    getIsNew () {
      this.$emit('getIsNew', this.isNew)
    },
    setDingtalkLastRemindDate() {
      this.getDingtalkLastRemindDates({
        workflowModelType: this.modelType,
        workflowModelId: this.quoteId
      }).then((resp) => {
        this.workflowLastRemindDates = resp.data
      })
    }
  }
}
</script>
<style lang="less" scoped>
.timeline {

  .ivu-icon-md-checkmark-circle:before {
    color: #c9c9c9;
  }
  .ivu-icon-md-checkmark-circle[active=true]:before {
    color: #52e039;
  }

  ul {
    list-style-type: none;
  }

  li {
    font-family: helvetica;
    line-height: 2.5em;
  }

  li.container.group {
    margin-top: 0.5em;

    div.group.title {
      color: #c9c9c9;
      text-transform: uppercase;
    }
  }

  ul.ivu-select-dropdown-list li,
  .user-text {
    color: #000; font-weight: normal;
  }

  .buttons div {
    display: inline-block;
  }

  .buttons div:first-child {
    margin-right: 15px;
  }

  .inline .message {
    padding: 0;
  }
}

</style>
